import { BlueTick } from "@/assets/icons";
import styles from "./slider.module.scss";
import { Button, Skeleton } from "antd";
import { useHistory } from "react-router-dom";
import { useState } from "react";

const SlideItem = ({ item }) => {
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(true);

  return (
    <div
      className={styles.slider_item}
      style={{
        backgroundImage: `url(${item.background})`,
        backgroundColor: "black",
      }}
    >
      <div className={styles.blur_item}>
        <div className={styles.item_info}>
          <h1>{item.title}</h1>
          {/* <div className={styles.by_author}>
            <span>by</span>
            <div className={styles.author}>
              <label>Danger Guy</label>
              <BlueTick />
            </div>
          </div> */}
          {/* <p>{item.description}</p>
          <Button
            className={styles.explore_btn}
            onClick={() => history.push(`/nft/detail/${item.id}`)}
          >
            Explore Now
          </Button> */}
        </div>
        <div className={styles.item_img}>
          {isLoading && <Skeleton.Image className={styles.loading} active />}
          <img
            src={item.avatar}
            alt=""
            loading="lazy"
            onLoad={() => setIsLoading(false)}
            style={{ height: isLoading ? 0 : "100%" }}
          />
        </div>
      </div>
    </div>
  );
};

export default SlideItem;
